import { useState, useMemo } from 'react';

export const useSortableTable = (data, defaultSortKey = null) => {
  const [sortConfig, setSortConfig] = useState(
    defaultSortKey 
      ? (typeof defaultSortKey === 'object' ? defaultSortKey : { key: defaultSortKey, direction: 'asc' })
      : null
  );

  const sortedData = useMemo(() => {
    if (!sortConfig || !data) return data;

    const parseDate = (val) => {
      if (!val || typeof val !== 'string') return null;
      const parts = val.split('/');
      if (parts.length === 3) {
        const [day, month, year] = parts;
        const fullYear = year.length === 2 ? '20' + year : year;
        const d = new Date(fullYear, parseInt(month) - 1, parseInt(day));
        if (!isNaN(d.getTime())) return d;
      }
      return null;
    };

    const sorted = [...data].sort((a, b) => {
      const aValue = sortConfig.key.includes('.') 
        ? sortConfig.key.split('.').reduce((obj, k) => obj?.[k], a) 
        : a[sortConfig.key];
      const bValue = sortConfig.key.includes('.') 
        ? sortConfig.key.split('.').reduce((obj, k) => obj?.[k], b) 
        : b[sortConfig.key];

      if (aValue === null || aValue === undefined) return 1;
      if (bValue === null || bValue === undefined) return -1;

      // Intentar comparar como fechas dd/MM/yy o dd/MM/yyyy
      const aDate = parseDate(aValue);
      const bDate = parseDate(bValue);
      if (aDate && bDate) {
        return sortConfig.direction === 'asc'
          ? aDate - bDate
          : bDate - aDate;
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortConfig.direction === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    return sorted;
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (columnName) => {
    if (!sortConfig || sortConfig.key !== columnName) return null;
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  return { sortedData, sortConfig, requestSort, getSortIcon };
};
